import React from 'react';
import { connect } from 'react-redux';
import CountUp from 'react-countup';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

function Summary({ overview }) {
  const items = [
    {
      title: 'Partitions',
      icon: 'producer',
      info: <CountUp end={overview.topicPartitionCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: 'Replications',
      icon: 'consumer',
      info: <CountUp end={overview.replicationCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: 'Min ISR',
      icon: 'subscription',
      info: <CountUp end={overview.equalMinISR} duration={0.4} />,
      unit: '个',
    },
  ];
  return <SummaryPanel shadow={false} img={null} items={items} />;
}

export default connect((state) => ({
  overview: state.kopTopic.detailOverview,
}))(Summary);
